angular.module('app.filters').filter('compositeStandard', function() {
    const STD_525_60 = 1;
    const STD_625_50 = 2;

    return function(std) {
        if (std == null) { return ''; }
        switch (std) {
            case STD_525_60:
                return '525@60';
            case STD_625_50:
                return '625@50';
            default:
                return `None or unknown (${std})`;
        }
    };
});


// WEBPACK FOOTER //
// ./filters/composite_standard.js